module.exports = __webpack_public_path__ + "static/media/akar-icons_chevron-right.28665751.svg";